import React from "react";

const CurrencyBody = ({ currency, rates }) => {
  return (
    <tbody className="admin_tbody">
      {currency.map((curr) => (
        <tr key={curr}>
          {" "}
          <td className="admin_exchange_curr">{curr}</td>
          <div className="admin_exchange_rate">
            {rates.map((rate, index) => (
              <td key={index}>
                <div className="admin_exchange_data">
                  <h4>{rate[curr] ? rate[curr].buyRate.toFixed(2) : 0}</h4>
                  <h4>{rate[curr] ? rate[curr].sellRate.toFixed(2) : 0}</h4>
                </div>
              </td>
            ))}
          </div>
          <td className="admin_exchange_refresh">
            <button>
              <i className="fa fa-refresh" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

export default CurrencyBody;
